var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment-actions d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"d-flex justify-content-start"},[_vm._t("left")],2),_c('div',{staticClass:"d-flex justify-content-end"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }